import { account, analytics } from '@silvertours/front-entities';
import React from 'react';
import { useTranslations } from 'next-intl';
import { useLogin } from '../../LoginForm';
import { List, NavigationItem, StyledLink } from './LoggedInActions.styles';

const LoggedInActions = () => {
  const { isLoggedIn } = useLogin();
  const { logout } = account.useAccountRequest();
  const t = useTranslations('features.navigationLegacy.login.menu');

  const accountLinks = [
    {
      id: 'accountMenuBookingsLink',
      text: t('items.myBookings.text'),
      href: t('items.myBookings.href'),
      onClick: () => {
        analytics.gtm.trackMyBookings({ isLoggedIn });
      },
    },
    {
      id: 'accountMenuProfileLink',
      text: t('items.myData.text'),
      href: t('items.myData.href'),
      onClick: () => {
        analytics.gtm.trackMyData({ isLoggedIn });
      },
    },
    {
      id: 'accountMenuPaymentLink',
      text: t('items.myPayment.text'),
      href: t('items.myPayment.href'),
      onClick: () => {
        analytics.gtm.trackMyPayment({ isLoggedIn });
      },
    },
    {
      id: 'accountMenuLogOutButton',
      text: t('items.logout.text'),
      onClick: () => {
        logout();
        analytics.gtm.trackLogout();
      },
    },
  ];

  return (
    <List role="menu" aria-label={t('button.loggedIn')}>
      {accountLinks.map((link, index) => (
        <React.Fragment key={`nav-${link.href}`}>
          {index === accountLinks.length - 1 && <hr />}
          <NavigationItem role="presentation">
            <StyledLink
              text={link.text}
              href={link.href}
              role="menuitem"
              onClick={link.onClick}
              as={link.href ? 'a' : 'button'}
              data-testid={link.id}
            />
          </NavigationItem>
        </React.Fragment>
      ))}
    </List>
  );
};

export { LoggedInActions };
